export default {
  is4DigitYear: /^\d{4}$/
}
